import { render, staticRenderFns } from "./adminAdd.vue?vue&type=template&id=00297602&"
import script from "./adminAdd.vue?vue&type=script&lang=js&"
export * from "./adminAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports